<template>
    <vx-card class="os-card-p overflow-hidden mr-10 my-3" >
        <template slot="no-body">
            <div class="px-4 py-4" @click="$emit('click-ticket', data)">
                <!-- Header: ID + Evidências + Copiar + Prioridade -->
                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
                    <div style="display: flex; align-items: center; gap: 6px;">
                        <span style="font-size: 12px; font-weight: 700; color: #94A3B8;">#{{ data.id }}</span>
                        <!-- Ícone / Badge de Anexos se houver evidência -->
                        <span
                          v-if="totalEvidencias > 0"
                          :title="totalEvidencias + (totalEvidencias === 1 ? ' anexo vinculado' : ' anexos vinculados')"
                          style="display: inline-flex; align-items: center; gap: 3px; padding: 2px 7px; background-color: #EFF6FF; border: 1px solid #BFDBFE; border-radius: 12px; font-size: 11px; color: #1D4ED8; font-weight: 600;"
                        >
                          <i class="material-icons" style="font-size: 13px;">attachment</i>
                          <span>{{ totalEvidencias }}</span>
                        </span>
                    </div>

                    <div style="display: flex; align-items: center; gap: 6px;">
                        <!-- Botão Copiar Dados do Ticket (Ctrl+C / Copy) -->
                        <button
                          type="button"
                          @click.stop="copiarInfoTicket()"
                          title="Copiar informações do ticket"
                          class="btn-copiar-card"
                          style="background: transparent; border: none; cursor: pointer; color: #94A3B8; padding: 2px 4px; border-radius: 4px; display: inline-flex; align-items: center;"
                        >
                          <i class="material-icons" style="font-size: 16px;">content_copy</i>
                        </button>
                        <Badge v-if="data.id_prioridade" :color="getPrioridadeColor(data.id_prioridade)" :text="getPrioridadeNome(data.id_prioridade)" style="font-size: 11px;"></Badge>
                    </div>
                </div>
                
                <!-- Title -->
                <h3 style="font-size: 15px; font-weight: 700; color: #1E293B; line-height: 1.3; margin-bottom: 6px;">
                    {{ data.nome }}
                </h3>
                
                <!-- Description (Higienizada, sem URLs ou sintaxe de markdown) -->
                <p
                  v-if="descricaoLimpa"
                  class="line-clamp-2"
                  :title="descricaoLimpa"
                  style="font-size: 13px; color: #64748B; margin-bottom: 10px; line-height: 1.4;"
                >
                    {{ descricaoLimpa }}
                </p>

                <!-- Preview da Primeira Evidência (Imagem com zoom, Vídeo ou Documento/PDF) -->
                <div
                  v-if="totalEvidencias > 0 && primeiraImagem"
                  class="card-evidence-preview-wrapper"
                  style="position: relative; width: 100%; height: 130px; border-radius: 8px; overflow: hidden; border: 1px solid #E2E8F0; margin-bottom: 12px; background-color: #F8FAFC; cursor: pointer;"
                  @click.stop="abrirPreviewPrimeiraEvidencia()"
                  :title="'Clique para abrir evidência: ' + obterNomeEvidencia(primeiraImagem, 0)"
                >
                  <!-- Se for Imagem Real -->
                  <img
                    v-if="obterTipoEvidencia(primeiraImagem) === 'image'"
                    :src="primeiraImagem"
                    style="width: 100%; height: 100%; object-fit: cover; display: block;"
                    :alt="'Evidência Ticket #' + data.id"
                  />

                  <!-- Se for Vídeo -->
                  <div
                    v-else-if="obterTipoEvidencia(primeiraImagem) === 'video'"
                    style="width: 100%; height: 100%; background-color: #0F172A; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 10px;"
                  >
                    <i class="material-icons" style="font-size: 42px; color: #60A5FA;">play_circle_filled</i>
                    <span style="color: #FFFFFF; font-size: 11px; font-weight: 600; margin-top: 4px; max-width: 90%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                      {{ obterNomeEvidencia(primeiraImagem, 0) }}
                    </span>
                  </div>

                  <!-- Se for PDF ou Documento -->
                  <div
                    v-else
                    style="width: 100%; height: 100%; background-color: #F1F5F9; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 10px;"
                  >
                    <i
                      class="material-icons"
                      :style="{ fontSize: '42px', color: obterTipoEvidencia(primeiraImagem) === 'pdf' ? '#DC2626' : '#2563EB' }"
                    >
                      {{ obterTipoEvidencia(primeiraImagem) === 'pdf' ? 'picture_as_pdf' : 'description' }}
                    </i>
                    <span style="color: #1E293B; font-size: 11px; font-weight: 600; margin-top: 4px; max-width: 90%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                      {{ obterNomeEvidencia(primeiraImagem, 0) }}
                    </span>
                  </div>

                  <!-- Overlay Superior: Badges e Botão de Download de todas as imagens -->
                  <div style="position: absolute; top: 6px; left: 6px; right: 6px; display: flex; justify-content: space-between; align-items: center; pointer-events: none;">
                    <!-- Badge Contador de Evidências -->
                    <span
                      style="background-color: rgba(15, 23, 42, 0.75); backdrop-filter: blur(2px); color: #FFFFFF; font-size: 11px; font-weight: 700; padding: 2px 8px; border-radius: 12px; display: inline-flex; align-items: center; gap: 4px;"
                    >
                      <i class="material-icons" style="font-size: 13px;">{{ obterTipoEvidencia(primeiraImagem) === 'image' ? 'photo_camera' : 'attachment' }}</i>
                      <span>{{ totalEvidencias === 1 ? '1 anexo' : ('1/' + totalEvidencias) }}</span>
                    </span>

                    <!-- Botãozinho de Download: Baixa arquivos anexados -->
                    <button
                      type="button"
                      @click.stop="baixarTodasDoCard()"
                      class="card-download-btn"
                      :title="totalEvidencias === 1 ? 'Baixar anexo' : 'Baixar todos os ' + totalEvidencias + ' anexos de uma vez'"
                      style="pointer-events: auto; background-color: rgba(15, 23, 42, 0.8); backdrop-filter: blur(2px); color: #FFFFFF; border: 1px solid rgba(255, 255, 255, 0.25); border-radius: 6px; padding: 3px 8px; font-size: 11px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 4px; transition: all 0.2s;"
                    >
                      <i class="material-icons" style="font-size: 14px; color: #34D399;">file_download</i>
                      <span>{{ totalEvidencias > 1 ? 'Baixar Todas' : 'Baixar' }}</span>
                    </button>
                  </div>

                  <!-- Overlay Inferior de Hover: Indicação de ação -->
                  <div
                    class="card-preview-hover-hint"
                    style="position: absolute; bottom: 0; left: 0; right: 0; padding: 6px 10px; background: linear-gradient(to top, rgba(15, 23, 42, 0.85), transparent); color: #FFFFFF; font-size: 11px; font-weight: 600; display: flex; align-items: center; justify-content: center; gap: 5px; opacity: 0; transition: opacity 0.2s;"
                  >
                    <i class="material-icons" style="font-size: 15px;">{{ obterTipoEvidencia(primeiraImagem) === 'image' ? 'zoom_in' : 'open_in_new' }}</i>
                    <span>{{ obterTipoEvidencia(primeiraImagem) === 'image' ? 'Ver no modal (1 por 1)' : 'Abrir anexo' }}</span>
                  </div>
                </div>

                <!-- Users Info Container -->
                <div style="background-color: #F8FAFC; border: 1px solid #F1F5F9; border-radius: 6px; padding: 10px; margin-bottom: 12px;">
                    <div style="display: flex; flex-direction: column; gap: 6px; font-size: 12px;">
                        <div style="display: flex; align-items: flex-start; color: #64748B;">
                            <span style="min-width: 85px; font-weight: 600; margin-right: 4px;">Responsável:</span>
                            <span style="font-weight: 700; color: #334155; word-break: break-word;">{{ data.nome_responsavel || 'Não Atribuído' }}</span>
                        </div>
                        <div style="display: flex; align-items: flex-start; color: #64748B;">
                            <span style="min-width: 85px; font-weight: 600; margin-right: 4px;">Criador:</span>
                            <span style="font-weight: 600; color: #475569; word-break: break-word;">{{ data.nome_criador }}</span>
                        </div>
                    </div>
                </div>

                <!-- Footer: Dates and Points -->
                <div style="display: flex; flex-direction: column; gap: 4px; font-size: 12px; color: #94A3B8;">
                    <div style="display: flex; justify-content: space-between; align-items: center;">
                        <span>Criado em: <strong style="color: #64748B; font-weight: 600;">{{ data.criado_em }}</strong></span>
                        <div v-if="data.pontos_funcao > 0">
                            <span style="padding: 2px 8px; background-color: #FEF3C7; color: #B45309; font-weight: 700; border-radius: 12px; font-size: 11px;">
                                {{ data.pontos_funcao }} pts
                            </span>
                        </div>
                    </div>
                    <div style="display: flex; justify-content: space-between; align-items: center;" v-if="data.prazo_exibicao || data.prazo">
                        <span :style="isAtrasado ? 'color: #EF4444;' : ''">Prazo: <strong :style="isAtrasado ? 'font-weight: 700;' : 'color: #64748B; font-weight: 600;'">{{ data.prazo_exibicao }}</strong></span>
                    </div>
                    <div style="display: flex; justify-content: space-between; align-items: center;" v-if="showConcluidoEm && data.concluido_em">
                        <span style="color: #059669;">Concluído: <strong style="font-weight: 600;">{{ data.concluido_em }}</strong></span>
                    </div>
                </div>
            </div>
        </template>
    </vx-card>
</template>

<script>
import Badge from '@/components/default/Badge.vue';

export default {
    name: 'KanbanTicket',
    components: {
        Badge,
    },
    props: {
        data: {
            type: Object,
            required: true
        },
        ticketPrioridades: {
            type: Array,
            default: () => []
        },
        hoje: {
            type: Date,
            default: () => new Date()
        },
        showConcluidoEm: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isAtrasado() {
            if (!this.data.prazo) return false;
            return new Date(this.data.prazo) < this.hoje;
        },
        imagensEvidencias() {
            if (!this.data || !this.data.descricao) return [];
            var desc = this.data.descricao;
            var urls = [];
            var mdRegex = /!?\[.*?\]\((https?:\/\/[^\s\)]+)\)/g;
            var m;
            while ((m = mdRegex.exec(desc)) !== null) {
                if (m[1] && urls.indexOf(m[1]) === -1) {
                    urls.push(m[1]);
                }
            }
            var directRegex = /(https?:\/\/[^\s\)]+\.(?:png|jpe?g|gif|webp|svg|pdf|docx?|xlsx?|txt|csv|mp4|webm|mov|zip|rar)|https:\/\/[^\s\)]*digitaloceanspaces\.com\/[^\s\)]+|https:\/\/i\.ibb\.co\/[^\s\)]+)/gi;
            while ((m = directRegex.exec(desc)) !== null) {
                if (m[1] && urls.indexOf(m[1]) === -1) {
                    urls.push(m[1]);
                }
            }
            return urls;
        },
        totalEvidencias() {
            return this.imagensEvidencias.length;
        },
        primeiraImagem() {
            return this.imagensEvidencias.length > 0 ? this.imagensEvidencias[0] : null;
        },
        descricaoLimpa() {
            if (!this.data || !this.data.descricao) return '';
            var desc = String(this.data.descricao);
            desc = desc.replace(/###\s*(?:Evidências|Anexos)\s*(\/\s*(?:Imagens|Arquivos))?[\s\S]*$/gi, '');
            desc = desc.replace(/!?\[.*?\]\([^\)]+\)/g, '');
            desc = desc.replace(/\[Ver (?:imagem|anexo) completa?\]\([^\)]+\)/gi, '');
            desc = desc.replace(/https?:\/\/[^\s\)]+\.(?:png|jpe?g|gif|webp|svg|pdf|docx?|xlsx?|txt|csv|mp4|webm|mov|zip|rar)/gi, '');
            desc = desc.replace(/https:\/\/[^\s\)]*digitaloceanspaces\.com\/[^\s\)]+/gi, '');
            desc = desc.replace(/https:\/\/i\.ibb\.co\/[^\s\)]+/gi, '');
            return desc.trim();
        }
    },
    methods: {
        obterTipoEvidencia(url) {
            if (!url) return 'image';
            var clean = String(url).split('?')[0].toLowerCase();
            if (/\.(png|jpe?g|gif|webp|svg)$/.test(clean)) return 'image';
            if (/\.(mp4|webm|mov|mkv|avi)$/.test(clean)) return 'video';
            if (/\.pdf$/.test(clean)) return 'pdf';
            if (/\.(docx?|xlsx?|txt|csv)$/.test(clean)) return 'document';
            if (/\.(zip|rar)$/.test(clean)) return 'archive';
            return 'image';
        },
        obterNomeEvidencia(url, idx) {
            if (!url) return 'anexo_' + ((idx || 0) + 1);
            var clean = String(url).split('?')[0];
            var parts = clean.split('/');
            var name = parts[parts.length - 1] || ('anexo_' + ((idx || 0) + 1));
            return decodeURIComponent(name.replace(/^\d+_/, ''));
        },
        abrirPreviewPrimeiraEvidencia() {
            if (!this.primeiraImagem) return;
            if (this.obterTipoEvidencia(this.primeiraImagem) === 'image') {
                this.$emit('open-lightbox', { ticket: this.data, index: 0, images: this.imagensEvidencias });
            } else {
                window.open(this.primeiraImagem, '_blank');
            }
        },
        baixarTodasDoCard() {
            if (!this.imagensEvidencias || this.imagensEvidencias.length === 0) return;
            var self = this;
            if (this.$vs && this.$vs.notify) {
                this.$vs.notify({
                    title: 'Baixando Evidências',
                    text: 'Iniciando o download de ' + this.imagensEvidencias.length + ' anexo(s) do ticket #' + this.data.id,
                    color: 'primary'
                });
            }
            for (var i = 0; i < this.imagensEvidencias.length; i++) {
                (function(index) {
                    setTimeout(function() {
                        var url = self.imagensEvidencias[index];
                        var nome = self.obterNomeEvidencia(url, index);
                        self.baixarArquivo(url, nome);
                    }, index * 400);
                })(i);
            }
        },
        baixarArquivo(url, nomeArquivo) {
            if (!url) return;
            var nome = nomeArquivo || ('evidencia_ticket_' + this.data.id + '.png');
            fetch(url)
                .then(function(res) { return res.blob(); })
                .then(function(blob) {
                    var blobUrl = window.URL.createObjectURL(blob);
                    var a = document.createElement('a');
                    a.href = blobUrl;
                    a.download = nome;
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(blobUrl);
                    document.body.removeChild(a);
                })
                .catch(function() {
                    window.open(url, '_blank');
                });
        },
        copiarInfoTicket() {
            var info = '[Ticket ' + this.data.id + '] ' + (this.data.nome || '') + '\n';
            if (this.data.nome_responsavel) info += 'Responsável: ' + this.data.nome_responsavel + '\n';
            if (this.data.nome_criador) info += 'Criador: ' + this.data.nome_criador + '\n';
            if (this.data.prazo_exibicao) info += 'Prazo: ' + this.data.prazo_exibicao + '\n';
            info += '\nDescrição:\n' + (this.data.descricao || '');

            if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(info);
            } else {
                var textArea = document.createElement('textarea');
                textArea.value = info;
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand('copy');
                document.body.removeChild(textArea);
            }

            if (this.$vs && this.$vs.notify) {
                this.$vs.notify({
                    title: 'Copiado!',
                    text: 'Informações do ticket ' + this.data.id + ' copiadas com sucesso',
                    color: 'success'
                });
            }
        },
        getPrioridadeNome(id) {
            if (!this.ticketPrioridades) return 'Normal';
            const p = this.ticketPrioridades.find(p => p.id === id);
            return p ? p.nome : '';
        },
        getPrioridadeColor(id) {
            if (!this.ticketPrioridades) return 'primary';
            const p = this.ticketPrioridades.find(p => p.id === id);
            if (!p || !p.nome) return 'primary';
            const nomeStr = String(p.nome).toUpperCase();
            if (nomeStr.includes('ALTA')) return 'danger';
            if (nomeStr.includes('MÉDIA') || nomeStr.includes('MEDIA')) return 'warning';
            if (nomeStr.includes('BAIXA')) return 'success';
            return 'primary';
        }
    }
}
</script>

<style scoped>
.line-clamp-2 {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;  
    overflow: hidden;
}
.btn-copiar-card:hover {
    color: #1E293B !important;
    background-color: #F1F5F9 !important;
}
.card-evidence-preview-wrapper {
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.card-evidence-preview-wrapper:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.12);
}
.card-evidence-preview-wrapper:hover .card-preview-hover-hint {
    opacity: 1 !important;
}
.card-download-btn:hover {
    background-color: #059669 !important;
    border-color: #10B981 !important;
    transform: scale(1.05);
}
.os-card:hover {
    /* box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06); */
    /* transition: all 0.25s ease; */
}
</style>
